import styled from 'styled-components';
import UmbrellaIconSvg from '../../assets/hotels/amenities/Umbrella.svg';

const UmbrellaIcon = styled(UmbrellaIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default UmbrellaIcon;
